import Vue from 'vue';
import { dialog } from '@/components/common/hll-dialog/index';

Vue.prototype.$dialog = dialog;
